// extracted by mini-css-extract-plugin
module.exports = {"timer-container":"timer_timer-container__y4EvL","timer-content":"timer_timer-content__20FXp","timer-content-ar":"timer_timer-content-ar__Kypzo"};